let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jSMGJ")).then(() => parcelRequire('372c6'));